module.exports = __webpack_public_path__ + "static/media/ladda_upp_bild.da2ba628.png";